import React from 'react';
import clsx from 'clsx';
import styles from './InfoCardGrid.module.css';

export interface InfoCardGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const InfoCardGrid: React.FC<InfoCardGridProps> = ({ className, children, ...props }) => {
  return (
    <div className={clsx(styles.infoCardGrid, className)} {...props}>
      {children}
    </div>
  );
};

export default InfoCardGrid;
